import { AutoCompleteOption } from '../../../../../../components/custom-form-controls/auto-complete'

type MaterialItem = { documentId: string; width: number }

export const findMaterialDocumentId = (
    value: unknown,
    materialOptions: AutoCompleteOption[],
    materials: MaterialItem[] = []
): string | undefined => {
    if (value === undefined || value === null || value === '') {
        return undefined
    }

    const trimmedValue = String(value).trim()

    const optionByKey = materialOptions.find(opt => String(opt.key) === trimmedValue)
    if (optionByKey?.key) {
        return String(optionByKey.key)
    }

    const optionByValue = materialOptions.find(opt => Number(opt.value) === Number(trimmedValue))
    if (optionByValue?.key) {
        return String(optionByValue.key)
    }

    const existingMaterial = materials.find(
        item => item.documentId === trimmedValue || item.width === Number(trimmedValue)
    )

    return existingMaterial?.documentId
}

export const createValidateMaterialWidth = (
    materialOptions: AutoCompleteOption[],
    materials: MaterialItem[] = []
) => {
    return (_: unknown, value: unknown) => {
        if (!value) {
            return Promise.resolve()
        }

        if (findMaterialDocumentId(value, materialOptions, materials)) {
            return Promise.resolve()
        }

        const stringValue = String(value).trim()
        const numInputValue = Number(stringValue)

        if (Number.isNaN(numInputValue)) {
            return Promise.reject(new Error('Введите число!'))
        }

        if (numInputValue % 5 !== 0) {
            return Promise.reject(new Error('Ширина должна быть кратна 5'))
        }

        if (numInputValue < 1 || numInputValue > 10000) {
            return Promise.reject(new Error('Ширина должна быть от 1 до 10000 мм'))
        }

        return Promise.resolve()
    }
}
